// import house images
import House1 from './assets/img/houses/house1.png';
import House2 from './assets/img/houses/house2.png';
import House3 from './assets/img/houses/house3.png';
import House4 from './assets/img/houses/house4.png';
import House5 from './assets/img/houses/house5.png';
import House6 from './assets/img/houses/house6.png';
import House7 from './assets/img/houses/house7.png';
import House8 from './assets/img/houses/house8.png';
import House9 from './assets/img/houses/house9.png';
import House10 from './assets/img/houses/house10.png';
import House11 from './assets/img/houses/house11.png';
import House12 from './assets/img/houses/house12.png';
// import house large images
import House1Lg from './assets/img/houses/house1lg.png';
import House2Lg from './assets/img/houses/house2lg.png';
import House3Lg from './assets/img/houses/house3lg.png';
import House4Lg from './assets/img/houses/house4lg.png';
import House5Lg from './assets/img/houses/house5lg.png';
import House6Lg from './assets/img/houses/house6lg.png';
import House7Lg from './assets/img/houses/house7lg.png';
import House8Lg from './assets/img/houses/house8lg.png';
import House9Lg from './assets/img/houses/house9lg.png';
import House10Lg from './assets/img/houses/house10lg.png';
import House11Lg from './assets/img/houses/house11lg.png';
import House12Lg from './assets/img/houses/house12lg.png';

// import apartments images
import Apartment1 from './assets/img/apartments/a1.png';
import Apartment2 from './assets/img/apartments/a2.png';
import Apartment3 from './assets/img/apartments/a3.png';
import Apartment4 from './assets/img/apartments/a4.png';
import Apartment5 from './assets/img/apartments/a5.png';
import Apartment6 from './assets/img/apartments/a6.png';
// import apartments large images
import Apartment1Lg from './assets/img/apartments/a1lg.png';
import Apartment2Lg from './assets/img/apartments/a2lg.png';
import Apartment3Lg from './assets/img/apartments/a3lg.png';
import Apartment4Lg from './assets/img/apartments/a4lg.png';
import Apartment5Lg from './assets/img/apartments/a5lg.png';
import Apartment6Lg from './assets/img/apartments/a6lg.png';

// import agents images
import Agent1 from './assets/img/agents/agent1.png';
import Agent2 from './assets/img/agents/agent2.png';
import Agent3 from './assets/img/agents/agent3.png';
import Agent4 from './assets/img/agents/agent4.png';
import Agent5 from './assets/img/agents/agent5.png';
import Agent6 from './assets/img/agents/agent6.png';
import Agent7 from './assets/img/agents/agent7.png';
import Agent8 from './assets/img/agents/agent8.png';
import Agent9 from './assets/img/agents/agent9.png';
import Agent10 from './assets/img/agents/agent10.png';
import Agent11 from './assets/img/agents/agent11.png';
import Agent12 from './assets/img/agents/agent12.png';

export const housesData = [
  {
    id: 1,
    type: 'House',
    name: 'House 1',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House1,
    image: House1Lg,
    country: 'United States',
    address: '7240C Argyle St. Lawndale, CA',
    bedrooms: '6',
    bathrooms: '3',
    surface: '4200 sq ft',
    date: "2022-08-21",
    year: '2016',
    price: '110000',
    agent: {
      images: Agent1,
      name: 'Patricia Tullert',
      phone: '0123 456 78910',
    },
  },
  {
    id: 2,
    type: 'House',
    name: 'House 2',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House2,
    image: House2Lg,
    country: 'Canada',
    address: '798 Talbot St. Bridgewater, NJ',
    bedrooms: '6',
    bathrooms: '3',
    surface: '4200 sq ft',
    date: "2022-09-21",
    year: '2016',
    
    price: '140000',
    agent: {
      images: Agent2,
      name: 'Daryl Hawker',
      phone: '0123 456 78910',
    },
  },
  {
    id: 3,
    type: 'House',
    name: 'House 3',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House3,
    image: House3Lg,
    country: 'United States',
    address: '2 Glen Creek St. Alexandria, VA',
    bedrooms: '6',
    bathrooms: '3',
    surface: '4200 sq ft',
    date: "2022-10-21",
    year: '2016',
    price: '170000',
    agent: {
      images: Agent3,
      name: 'Amado Smith',
      phone: '0123 456 78910',
    },
  },
  {
    id: 4,
    type: 'House',
    name: 'House 4',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House4,
    image: House4Lg,
    country: 'Canada',
    address: '84 Woodland St. Cocoa, FL',
    bedrooms: '6',
    bathrooms: '3',
    surface: '4200 sq ft',
    date: "2022-11-21",
    year: '2016',
    price: '200000',
    agent: {
      images: Agent4,
      name: 'Kaitlyn Gonzalez',
      phone: '0123 456 78910',
    },
  },
  {
    id: 5,
    type: 'House',
    name: 'House 5',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House5,
    image: House5Lg,
    country: 'United States',
    address: '28 Westport Dr. Warminster, PA',
    bedrooms: '5',
    bathrooms: '3',
    surface: '4200 sq ft',
    date: "2022-12-21",
    year: '2015',
    price: '210000',
    agent: {
      images: Agent5,
      name: 'Grover Robinson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 6,
    type: 'House',
    name: 'House 6',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House6,
    image: House6Lg,
    country: 'Canada',
    address: '32 Pawnee Street Butte, MT',
    bedrooms: '6',
    bathrooms: '3',
    surface: '6200 sq ft',
    date: "2023-01-21",
    year: '2014',
    price: '220000',
    agent: {
      images: Agent6,
      name: 'Karen Sorensen',
      phone: '0123 456 78910',
    },
  },
  {
    id: 7,
    type: 'Apartment',
    name: 'Apartment 1',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: Apartment1,
    image: Apartment1Lg,
    country: 'Canada',
    address: '32 Pawnee Street Butte, MT',
    bedrooms: '2',
    bathrooms: '1',
    surface: '1200 sq ft',
    date: "2023-02-21",
    year: '2012',
    price: '20000',
    agent: {
      images: Agent7,
      name: 'Jawhar Shamil Naser',
      phone: '0123 456 78910',
    },
  },
  {
    id: 8,
    type: 'Apartment',
    name: 'Apartment 2',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: Apartment2,
    image: Apartment2Lg,
    country: 'United States',
    address: '28 Westport Dr. Warminster, PA',
    bedrooms: '3',
    bathrooms: '1',
    surface: '1000 sq ft',
    date: "2023-03-21",
    year: '2011',
    price: '30000',
    agent: {
      images: Agent8,
      name: 'Juana Douglass',
      phone: '0123 456 78910',
    },
  },
  {
    id: 9,
    type: 'Apartment',
    name: 'Apartment 3',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: Apartment3,
    image: Apartment3Lg,
    country: 'United States',
    address: '84 Woodland St. Cocoa, FL',
    bedrooms: '2',
    bathrooms: '1',
    surface: '1100 sq ft',
    date: "2023-04-21",
    year: '2011',
    price: '40000',
    agent: {
      images: Agent9,
      name: 'Jerry Schenck',
      phone: '0123 456 78910',
    },
  },
  {
    id: 10,
    type: 'House',
    name: 'House 7',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House7,
    image: House7Lg,
    country: 'Canada',
    address: '7240C Argyle St. Lawndale, CA',
    bedrooms: '5',
    bathrooms: '3',
    surface: '3200 sq ft',
    date: "2023-05-21",
    year: '2015',
    price: '117000',
    agent: {
      images: Agent10,
      name: 'Vera Levesque',
      phone: '0123 456 78910',
    },
  },
  {
    id: 11,
    type: 'House',
    name: 'House 8',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House8,
    image: House8Lg,
    country: 'Canada',
    address: '798 Talbot St. Bridgewater, NJ',
    bedrooms: '7',
    bathrooms: '2',
    surface: '2200 sq ft',
    date: "2023-06-21",
    year: '2019',
    price: '145000',
    agent: {
      images: Agent11,
      name: 'Sofia Gomes',
      phone: '0123 456 78910',
    },
  },
  {
    id: 12,
    type: 'House',
    name: 'House 9',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House9,
    image: House9Lg,
    country: 'United States',
    address: '2 Glen Creek St. Alexandria, VA',
    bedrooms: '4',
    bathrooms: '4',
    surface: '4600 sq ft',
    date: "2023-07-21",
    year: '2015',
    price: '139000',
    agent: {
      images: Agent12,
      name: 'Raymond Hood',
      phone: '0123 456 78910',
    },
  },
  {
    id: 13,
    type: 'House',
    name: 'House 10',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House10,
    image: House10Lg,
    country: 'Canada',
    address: '84 Woodland St. Cocoa, FL',
    bedrooms: '5',
    bathrooms: '2',
    surface: '5200 sq ft',
    date: "2023-08-21",
    year: '2014',
    price: '180000',
    agent: {
      images: Agent1,
      name: 'Patricia Tullert',
      phone: '0123 456 78910',
    },
  },
  {
    id: 14,
    type: 'House',
    name: 'House 11',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House11,
    image: House11Lg,
    country: 'United States',
    address: '28 Westport Dr. Warminster, PA',
    bedrooms: '5',
    bathrooms: '2',
    surface: '3200 sq ft',
    date: "2023-09-21",
    year: '2011',
    price: '213000',
    agent: {
      images: Agent2,
      name: 'Daryl Hawker',
      phone: '0123 456 78910',
    },
  },
  {
    id: 15,
    type: 'House',
    name: 'House 12',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: House12,
    image: House12Lg,
    country: 'Canada',
    address: '32 Pawnee Street Butte, MT',
    bedrooms: '4',
    bathrooms: '3',
    surface: '5200 sq ft',
    date: "2023-12-21",
    year: '2013',
    price: '221000',
    agent: {
      images: Agent3,
      name: 'Amado Smith',
      phone: '0123 456 78910',
    },
  },
  {
    id: 16,
    type: 'Apartment',
    name: 'Apartment 16',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: Apartment4,
    image: Apartment4Lg,
    country: 'Canada',
    address: '32 Pawnee Street Butte, MT',
    bedrooms: '2',
    bathrooms: '1',
    surface: '1300 sq ft',
    date: "2023-02-21",
    year: '2011',
    price: '21000',
    agent: {
      images: Agent4,
      name: 'Kaitlyn Gonzalez',
      phone: '0123 456 78910',
    },
  },
  {
    id: 17,
    type: 'Apartment',
    name: 'Apartment 17',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: Apartment5,
    image: Apartment5Lg,
    country: 'United States',
    address: '28 Westport Dr. Warminster, PA',
    bedrooms: '3',
    bathrooms: '1',
    surface: '1000 sq ft',
    date: "2023-08-21",
    year: '2012',
    price: '32000',
    agent: {
      images: Agent5,
      name: 'Grover Robinson',
      phone: '0123 456 78910',
    },
  },
  {
    id: 18,
    type: 'Apartment',
    name: 'Apartment 18',
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
    images: Apartment6,
    image: Apartment6Lg,
    country: 'Canada',
    address: '84 Woodland St. Cocoa, FL',
    bedrooms: '3',
    bathrooms: '1',
    surface: '1200 sq ft',
    date: "2023-11-21",
    year: '2010',
    price: '38000',
    agent: {
      images: Agent6,
      name: 'Karen Sorensen',
      phone: '0123 456 78910',
    },
  },
];
